import { signalStore } from '@ngrx/signals';
import { withProjectData } from './features/with-project-data';
import { withFeatureFlags } from './features/with-feature-flags';
import { withProcore } from './features/with-procore';
import { withSensors } from './features/with-sensors';
import { withQcConfig } from './features/with-qc-config';
import { withWbs } from './features/with-wbs';
import { withProjectRoles } from './features/with-project-roles';
import { withHydration } from './features/with-hydration';

/**
 * Global signal store for the currently loaded construction project.
 *
 * Composed of the following features:
 *   - withProjectData       — project entity, lastEventStatus, lastDroneImage, core computed signals
 *   - withFeatureFlags      — feature flag list and permission map
 *   - withProcore           — active Procore users, Procore integration setter
 *   - withSensors           — sensor list, Flytbase site ID, NextPower ID setters
 *   - withQcConfig          — QC types, scopes, and published flag
 *   - withWbs               — WBS element weights, visibility, plan-dates config, work-hours lookup
 *   - withProjectRoles      — role predicates, available roles, preferred data-source perspective
 *   - withHydration         — single entry point to hydrate all of the above from a loaded project
 */
export const ConstructionProjectSignalStore = signalStore(
  { providedIn: 'root' },
  withProjectData(),
  withFeatureFlags(),
  withProcore(),
  withSensors(),
  withQcConfig(),
  withWbs(),
  withProjectRoles(),
  withHydration(),
);
